const localizers = {
  'loading.msg': () => `Betöltés...`,
  'logon.message.msg': () => `Hitelesítés szükséges. Adjon meg egy érvényed felhasználói azonosítót és jelszót.`,
  'logon.button.msg': () => `Bejelentkezés...`,
  'SASServer.logonError.msg': () => `Nem lehet bejelentkezni a kiszolgálóra.`,
  'SASServer.genericError.msg': () => `A kiszolgáló nem érhető el.`,
}
export default localizers;
